<template>
  <header class="tw-sticky tw-top-0 tw-z-[50] tw-bg-white">
    <!-- новая шапка -->
    <div
      class="tw-bg-[#0A3982] tw-flex tw-gap-[10px] tw-justify-between tw-h-[81px] tw-px-[26px] tw-text-white tw-text-[12px] tw-relative [&_*]:tw-outline-none"
    >
      <div class="tw-flex tw-text-white tw-items-center tw-gap-[30px]">
        <router-link :to="{ path: '/welcome' }">
          <img
            :src="require(`@/assets/images/logo.svg`)"
            class="tw-w-full tw-max-w-[180px]"
          />
        </router-link>

        <div class="tw-hidden 2xl:tw-block">
          {{ aboutUser.crm_build_info }}
        </div>
      </div>

      <div class="tw-block xl:tw-hidden"></div>

      <div class="tw-flex tw-gap-[20px] xl:tw-gap-[40px]">
        <HeaderMenu
          :isBroadcasting="isBroadcasting"
          :broadcastingLink="broadcastingLink"
          :dataLang="dataLang"
        />

        <div
          class="tw-bg-white tw-opacity-[18%] tw-w-[1px] tw-h-[58px] tw-mt-[15px]"
        ></div>

        <div
          class="tw-flex tw-justify-center tw-gap-[4px] tw-flex-col tw-pt-[10px]"
        >
          <div class="tw-flex tw-gap-[5px]">
            <span class="tw-text-lightText">Статус:</span>
            <span
              @click="$modal.show('statusAndRating')"
              class="tw-font-bold tw-cursor-pointer hover:tw-underline"
            >
              {{ dataLang[aboutUser?.company_status_by_rating] }}
            </span>
          </div>
          <div class="tw-flex tw-gap-[5px]">
            <span class="tw-text-lightText">Рейтинг:</span>
            <span
              @click="$modal.show('statusAndRating')"
              class="tw-font-bold tw-cursor-pointer hover:tw-underline tw-truncate"
            >
              {{ fixedCompanyRating }} из 100
            </span>
          </div>
          <StatusAndRating
            :aboutUser="aboutUser"
            :fixedCompanyRating="fixedCompanyRating"
            :rawCompanyRating="aboutUser?.company_rating"
          />
        </div>

        <div
          class="tw-bg-white tw-opacity-[18%] tw-w-[1px] tw-h-[58px] tw-mt-[15px]"
        ></div>

        <div
          class="tw-flex tw-justify-center tw-gap-[4px] tw-flex-col tw-pt-[10px]"
        >
          <div class="tw-flex tw-gap-[5px]">
            <span class="tw-text-lightText">Баланс:</span>
            <span class="tw-font-bold tw-truncate">
              {{ aboutUser?.company_balance?.split(".")?.join(",") }}
              <span class="tw-font-normal">₽</span></span
            >
            <div
              class="tw-w-[18px] tw-h-[18px] tw-bg-warning tw-flex tw-rounded-[3px] tw-items-center tw-justify-center tw-cursor-pointer tw-ml-[10px]"
              @click="$modal.show('onAddBalance')"
            >
              <img
                :src="require(`@/assets/icons/add-2-dark.svg`)"
                width="7.6"
              />
            </div>
            <div
              class="tw-w-[18px] tw-h-[18px] tw-bg-[#8000FF] tw-flex tw-rounded-[3px] tw-items-center tw-justify-center tw-cursor-pointer"
              @click="$modal.show('withdrawalOfFundsModal')"
            >
              <img
                :src="require(`@/assets/icons/toTop.svg`)"
                width="8.5"
                height="9.75"
              />
            </div>
          </div>
          <div class="tw-flex tw-gap-[5px]">
            <span class="tw-text-lightText">Баллов:</span>
            <span
              @click="$modal.show('companyScore')"
              class="tw-cursor-pointer hover:tw-underline"
              >{{ aboutUser?.company_score?.replace(".", ",") }}</span
            >
          </div>
          <CompanyScore :aboutUser="aboutUser" />
        </div>

        <div
          class="tw-bg-white tw-opacity-[18%] tw-w-[1px] tw-h-[58px] tw-mt-[15px]"
        ></div>

        <div class="tw-flex tw-gap-[15px]">
          <router-link
            :to="{ path: '/company_notifications' }"
            href="/company_notifications"
            class="tw-relative tw-w-[42px] tw-flex !tw-text-white"
          >
            <img
              v-if="countNotices > 0"
              :src="require('@/assets/header-icons/bell.svg')"
              class="tw-w-[21px] cursor-pointer"
              draggable="false"
            />
            <img
              v-if="countNotices == 0"
              :src="require('@/assets/header-icons/bell-full.svg')"
              class="tw-w-[21px] cursor-pointer"
              draggable="false"
            />
            <div
              v-if="countNotices > 0"
              class="tw-absolute tw-top-[23px] tw-left-[12px] tw-inline-flex tw-bg-[#FF3A20] tw-p-[3px] tw-pr-[4px] tw-rounded-[3px] tw-text-[9px] tw-font-[500] tw-leading-[11px]"
            >
              {{ countNotices }}
            </div>
          </router-link>
          <div v-click-outside="setUserInfoVisible" class="tw-flex tw-items-center">
            <div
              @click="userInfoVisible = !userInfoVisible"
              class="tw-flex tw-flex-col tw-items-center cursor-pointer"
            >
              <div
                class="tw-border-[1px] tw-border-solid tw-border-[#BDF300] tw-rounded-full tw-w-[42px] tw-h-[42px] tw-flex tw-items-center tw-justify-center"
              >
                <img
                  v-if="aboutUser.employee_is_admin"
                  :src="require(`@/assets/header-icons/a.svg`)"
                  class=""
                />
                <img
                  v-if="!aboutUser.employee_is_admin"
                  :src="require(`@/assets/header-icons/user.svg`)"
                  class=""
                />
              </div>
              <img
                :src="require(`@/assets/header-icons/pro.svg`)"
                class="tw-h-[12px] tw-mt-[-7px]"
              />
            </div>
            <!-- модалка юзера -->
            <UserInfo
              :userInfoVisible="userInfoVisible"
              :aboutUser="aboutUser"
              :userSetting="userSetting"
            />
            <!-- модалка юзера -->
          </div>
        </div>
      </div>
    </div>
    <!-- новая шапка -->
    <!-- <TheMenu :openMenu="isActive" @closeMenu="closeMainMenu"></TheMenu> -->
    <!-- новое меню -->
    <Menu :openMenu="isActive" @closeMenu="closeMainMenu"></Menu>
    <!-- новое меню -->
    <BaseModal
      name="support"
      width="420"
      height="auto"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      @beforeOpen=""
      @beforeClose=""
      classes="bg-transparent shadow-none"
    >
      <div class="bg-white rounded-25 pt-20 pb-30 px-30 h-100">
        <div class="d-flex justify-content-end mb-5">
          <button
            type="button"
            class="btn-close"
            @click="$modal.hide('support')"
          ></button>
        </div>
        <div>
          <p class="fs-5 mb-0 text-center">Направьте свой запрос</p>
          <p class="fs-5 mb-0 text-center">на электронную почту</p>
          <p class="fs-5 mb-5 text-center">
            <a class="dark-blue" href="mailto:support@sirius.rent"
              >support@sirius.rent</a
            >
          </p>
          <p class="fs-7 text-center">(Ответ от 10 минут до 24 часов)</p>
          <p class="fs-7 text-center my-15 py-15 border-top border-bottom">
            Не забудьте указать SID
          </p>
          <p class="fs-7 mb-5 text-center text-muted">
            Срочная поддержка, которая не ждёт
          </p>
          <p class="mb-0 text-center dark-blue">
            +7 (495) 146-50-30 (доб. 999)
          </p>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="onAddBalance"
      width="420"
      height="auto"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      @beforeOpen=""
      @beforeClose="beforeClose"
      classes="!tw-bg-transparent !tw-shadow-none"
    >
      <div
        class="tw-bg-white tw-rounded-[25px] tw-pt-[38px] tw-px-[30px] tw-pb-[48px] tw-relative tw-text-forTitle"
      >
        <button
          type="button"
          class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
          @click="$modal.hide('onAddBalance')"
        ></button>
        <div class="tw-text-center">
          <div class="tw-text-[23px] tw-mb-[15px]">Пополнить баланс</div>
          <BaseInputNew
            inputClass="tw-app-input-type-3 tw-mb-[15px]"
            placeholder=""
            :width="'380'"
            :input-name="'summForPayment'"
            @input="(data) => callbackForSum(data)"
            value=""
            name-sign=""
            :forFinanceType="true"
            inputRef="summForPayment__1"
          >
          </BaseInputNew>
          <BaseSelect
            class="multiselect-type-3"
            placeholder=""
            selectLabel=""
            deselectLabel=""
            :maxHeight="150"
            label="label"
            @input="onLoadVin"
            v-model="valueMethods"
            :options="listPaymentMethodsFiltered"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template
            ><template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
          <div
            v-if="valueMethods.value == `SPB`"
            class="tw-text-[15px] tw-mt-[15px]"
          >
            Итого с учетом комиссии: {{ summForPaymentWithPercent }}
          </div>
          <div
            v-if="valueMethods.value != `SPB`"
            class="tw-text-[15px] tw-mt-[15px]"
          >
            Итого: {{ summForPaymentWithPercent }}
          </div>
          <button
            @click="onAddBalance"
            class="tw-app-btn-muted tw-app-btn-muted-lg tw-mx-auto tw-mt-[30px] !tw-text-[14px] tw-min-w-[120px] tw-justify-center !tw-leading-[130%]"
          >
            Далее
          </button>
        </div>
      </div>
    </BaseModal>

    <WithdrawalOfFundsModal />

    <BaseModal
      name="generatedDoc"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      @beforeOpen=""
      @beforeClose=""
      height="auto"
      classes="!tw-bg-transparent !tw-shadow-none"
    >
      <div
        class="tw-overflow-hidden tw-bg-white tw-rounded-[25px] tw-pt-[38px] tw-px-[30px] tw-pb-[48px] tw-relative tw-text-forTitle"
      >
        <BaseLoader v-if="localLoading"></BaseLoader>
        <button
          type="button"
          class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
          @click="$modal.hide('generatedDoc')"
        ></button>
        <div class="tw-text-[15px]">
          <div class="tw-text-center tw-text-[23px] tw-mb-[15px]">
            {{ dataLang["reg_fin_text_88"] }}
          </div>
          <div class="tw-text-forTitle tw-font-bold">
            {{ dataLang["reg_fin_text_69"] }}:
          </div>
          <div
            class="tw-text-forText"
            v-html="dataLang['reg_fin_text_89']"
          ></div>
          <button
            @click="loadDoc"
            class="tw-app-btn-primary tw-app-btn-primary-lg tw-mx-auto tw-mt-[30px] !tw-text-[14px] tw-min-w-[120px] tw-justify-center !tw-leading-[130%]"
          >
            {{ dataLang["reg_fin_text_90"] }}
          </button>
        </div>
      </div>
    </BaseModal>
  </header>
</template>

<script>
import ClickOutside from "@/directives/click-outside.js";
// import TheMenu from "@/components/TheMenu.vue";
import Menu from "@/components/Menu.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import UserInfo from "@/components/header/UserInfo.vue";
import AboutUser from "@/api/AboutUser.js";
import { mapActions, mapState, mapMutations } from "vuex";
import GeneralService from "@/api/GeneralService";
import { debounce } from "lodash";
import axios from "axios";
import EventBus from "@/event-bus.js";
import StatusAndRating from "@/components/StatusAndRating.vue";
import CompanyScore from "@/components/CompanyScore.vue";
import WithdrawalOfFundsModal from "@/components/finreestr/WithdrawalOfFundsModal.vue";

export default {
  directives: {
    ClickOutside,
  },
  components: {
    // TheMenu,
    Menu,
    UserInfo,
    HeaderMenu,
    StatusAndRating,
    CompanyScore,
    WithdrawalOfFundsModal,
  },
  data() {
    return {
      userInfoVisible: false,
      isBroadcasting: false,
      broadcastingLink: "",
      isActive: false,
      aboutUser: {},
      count_notices: 0,
      localLoading: false,
      listPaymentMethods: [],
      valueMethods: {},
      typePin: "",
      fullSum: 0,
      callbackForSum: () => {},
      summForPayment: 0,
      summForPaymentWithPercent: 0,
      API_PATH: "",
      sseInstance: null,
    };
  },
  methods: {
    setUserInfoVisible() {
      this.userInfoVisible = false;
    },
    async checkAmount() {
      // Pre-check реквизитов пользователя перед генерацией счета (PDF) через converter.
      if (
        this.valueMethods.value == "BankCard" ||
        this.valueMethods.value == "SPB"
      ) {
        const BankCardCheck = await GeneralService.get(`/caniuse/payByCard`, {
          params: {
            amount: this.summForPayment,
          },
        });
        const BankCardCheckData = BankCardCheck?.data ?? {};
        const checkCode =
          BankCardCheckData?.code ?? BankCardCheckData?.data?.code;
        if (checkCode === 400) {
          const message =
            BankCardCheckData?.message ??
            BankCardCheckData?.data?.message ??
            "Ошибка выставления счета!";
          this.$toast.error(message, { duration: 5000 });
        }
      } else {
        const invoiceCheck = await GeneralService.get(
          `/caniuse/generatePaymentInvoice`,
          {
            params: {
              amount: this.summForPayment,
            },
          }
        );
        const invoiceCheckData = invoiceCheck?.data ?? {};
        const checkCode =
          invoiceCheckData?.code ?? invoiceCheckData?.data?.code;
        if (checkCode === 400) {
          const message =
            invoiceCheckData?.message ??
            invoiceCheckData?.data?.message ??
            "Ошибка выставления счета! Заполните все реквизиты в разделе 719 и повторите попытку!";
          this.$toast.error(message, { duration: 5000 });
        }
      }
    },
    checkStream() {
      GeneralService.get(`/broadcasting`)
        .then((res) => {
          this.isBroadcasting = !!res.data?.data?.isBroadcasting;
          this.broadcastingLink = res.data?.data?.broadcastingLink ?? "";
        })
        .catch((e) => {
          console.log(e);
        });
    },
    beforeClose() {
      this.summForPayment = 0;
      this.summForPaymentWithPercent = 0;
      this.valueMethods = this.listPaymentMethods[0];
    },
    closeMainMenu() {
      this.isActive = false;
    },
    onLoadVin() {
      if (this.valueMethods == this.listPaymentMethods[2]) {
        this.summForPaymentWithPercent = this.summForPayment;
      }
      if (
        this.summForPayment &&
        this.valueMethods !== this.listPaymentMethods[2]
      ) {
        GeneralService.get(
          `/payment/calc-price?amount=${this.summForPayment}&payment_method=${this.valueMethods.value}`
        )
          .then((data) => {
            this.summForPaymentWithPercent = data.data.data.price;
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message, { duration: 5000 });
          });
      }
    },
    async onAddBalance() {
      let API_PATH = "";
      switch (process.env.VUE_APP_MODE_BUILD) {
        case "serve-hmr":
          API_PATH = `http://converter.sirius.development`;
          break;
        case "production":
          API_PATH = `https://crmrent.com`;
          break;
        case "testing":
          API_PATH = `https://crmtest.ru`;
          break;
        case "development":
          API_PATH = `http://sirius.development`;
          break;
      }
      GeneralService.get(`/whoami`)
        .then(async (data) => {
          await this.checkAmount();
          if (
            this.valueMethods !== this.listPaymentMethods[2] &&
            this.summForPayment
          ) {
            GeneralService.editOrCreate(
              `/companies/${data.data.data.company_lc}/balance/up`,
              {
                amount: this.summForPayment,
                return_url: `${API_PATH}/finreestr`,
                payment_method: this.valueMethods.value,
              }
            )
              .then((data) => {
                window.location.href = data.data.data.url;
              })
              .catch((e) => {
                this.$toast.error(e.response.data.message, { duration: 5000 });
              });
          } else {
            this.$modal.show("generatedDoc");
          }
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message, { duration: 5000 });
        });
    },

    async loadDoc() {
      let API_PATH = "";
      // if (process.env.VUE_APP_MODE_BUILD == 'serve-hmr' || process.env.VUE_APP_MODE_BUILD == 'testing') {
      //   API_PATH = 'crmtest'
      // } else {
      //   API_PATH = 'crmrent'
      // }

      switch (process.env.VUE_APP_MODE_BUILD) {
        case "serve-hmr":
          API_PATH = `http://converter.sirius.development`;
          break;
        case "production":
          API_PATH = `https://converter.crmrent.com`;
          break;
        case "testing":
          API_PATH = `https://converter.crmtest.ru`;
          break;
        case "development":
          API_PATH = `http://converter.sirius.development`;
          break;
      }
      const closeModalsOnSuccess = true;
      let shouldClose = false;
      try {
        this.localLoading = true;
        await this.checkAmount();
        let dataFrom = await axios.get(
          `${API_PATH}/generate-pdf?amount=${this.summForPayment}`,
          {
            responseType: "blob",
            headers: {
              "X-Employee-Token": JSON.parse(
                localStorage.getItem("user-token")
              ),
              "Access-Control-Allow-Origin": "*",
            },
          }
        );
        const url = window.URL.createObjectURL(dataFrom.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Счет на оплату от ${this.$time().format(
          "DD.MM.YYYY"
        )}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        shouldClose = closeModalsOnSuccess;
      } catch (error) {
        // В случае ошибки прекратим генерацию и покажем сообщение пользователю.
        const message =
          error?.response?.data?.message ??
          "Ошибка выставления счета! Заполните все реквизиты в разделе №719 и повторите попытку!";
        this.$toast.error(message, { duration: 5000 });
      } finally {
        this.localLoading = false;
        if (shouldClose) {
          this.$modal.hide("generatedDoc");
          this.$modal.hide("onAddBalance");
        }
      }
    },
    // signOut() {
    //   localStorage.removeItem("user-token");
    //   localStorage.removeItem("translations");
    //   localStorage.removeItem("loginAt");
    //   this.$router.push("/auth");
    // },
    toggleMenu() {
      this.isActive = !this.isActive;
    },
    updateUserInfo() {
      AboutUser.getAllAboutUser()
        .then((data) => {
          this.aboutUser = data.data.data;

          this.getUserSetting(data.data.data);
        })
        .then((err) => {});
    },
    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },
    ...mapActions("userSettingModule", [
      "getUserSetting",
      "setUserNotification",
    ]),
  },
  beforeDestroy() {
    EventBus.$off("headerUserInfoEventBus");
  },
  mounted() {
    EventBus.$on("headerUserInfoEventBus", (payload) => {
      this.updateUserInfo();
    });
    this.checkStream();
    GeneralService.get(`/selects/field/balance_type_payment_method`)
      .then((data) => {
        this.listPaymentMethods = this.prepareLabelsForDefaultSelects(
          data.data.data.rows,
          "allSelects",
          true
        ).balance_type_payment_method;

        this.valueMethods = this.listPaymentMethods[0];
      })
      .catch((e) => {
        if (e.response) {
          this.$toast.error(e.response.data.message, { duration: 5000 });
        } else {
          console.error(e);
        }
      });

    this.callbackForSum = debounce((data) => {
      data.value = data.value?.replace(",", ".");
      this.summForPayment = data.value;
      if (this.valueMethods !== this.listPaymentMethods[2]) {
        GeneralService.get(
          `/payment/calc-price?amount=${data.value}&payment_method=${this.valueMethods.value}`
        )
          .then((data) => {
            this.summForPaymentWithPercent = data.data.data.price;
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message, { duration: 5000 });
          });
      }
      if (this.valueMethods == this.listPaymentMethods[2]) {
        this.summForPaymentWithPercent = data.value;
      }
    }, 200);
  },
  created() {
    let API_PATH;
    switch (process.env.VUE_APP_MODE_BUILD) {
      case "serve-hmr":
        API_PATH = "http://sse.sirius.development";
        break;
      case "development":
        API_PATH = "http://sse.sirius.development";
        break;
      case "production":
        API_PATH = "https://sse.crmrent.com";
        break;
      case "testing":
        API_PATH = "https://sse.crmtest.ru";
        break;
    }

    this.sseInstance = new EventSource(
      API_PATH + `/?token=${JSON.parse(localStorage.getItem("user-token"))}`
    );
    this.updateUserInfo();
    this.sseInstance.addEventListener("newNotification", (event) => {
      this.setUserNotification();
      let infoMessage = JSON.parse(event.data);
      this.$toast.info(infoMessage.message, { duration: 5000 });
    });
    this.setUserNotification();
  },
  unmounted() {
    sseInstance.removeEventListener("newNotification");
    this.sseInstance = null;
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting", "countNotices"]),
    fixedCompanyRating() {
      const num = Number(this.aboutUser?.company_rating);
      if (
        this.aboutUser?.company_rating === null ||
        this.aboutUser?.company_rating === undefined ||
        isNaN(num) ||
        String(this.aboutUser?.company_rating).trim() === ""
      ) {
        return "0";
      }
      return num.toFixed();
    },
    listPaymentMethodsFiltered() {
      return this.listPaymentMethods.filter((i) => i.value != "BankCard");
    },
  },
  watch: {
    $route(to, from) {
      this.userInfoVisible = false;
    },
  },
};
</script>

<style lang="scss"></style>
